import { gql } from '@apollo/client'

export const ProductBaseFieldsFragment = gql`
  fragment ProductBaseFields on Product {
    id
    xid
    name
    slug

    price
    oldPrice
    price_type
    
    isWeightProduct
    count_multiplier
    isFavorite
    stock {
      amount
    }
    preview {
      url
    }
    review_count
    marketingLabels {
      id
      title
      description
      image(style:  "600xauto") {
        url
      }
      activeFrom
      activeUntil
      optionColor
      optionBackgroundColor
      optionLink
      optionLinkLabel
    }
    is_alcohol
  }
`

export const ProductPriceOffersFieldsFragment = gql`
  fragment ProductPriceOffersFields on Product {
    priceOffers {
      id
      price
      oldPrice
      salePeriod {
        start
        finish
      }
      min
      max
      step
      quant
      uiQuant
      quantAmount
      isDefault
      group
    }
  }
`

export const ProductPriceOfferFieldsFragment = gql`
  fragment ProductPriceOfferFields on Product {
    priceOffer @client {
      id
      price
      oldPrice
      count_multiplier
      salePeriod {
        start
        finish
      }
      min
      max
      step
      quant
      quantAmount
      isDefault
      group
    }
  }
`

export const ProductWithOfferFragment = gql`
  fragment ProductWithOffer on Product {
    ...ProductBaseFields
    ...ProductPriceOffersFields
    ...ProductPriceOfferFields
  }
  ${ProductBaseFieldsFragment}
  ${ProductPriceOffersFieldsFragment}
  ${ProductPriceOfferFieldsFragment}
`
